import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { FeatureCode } from '../../subscription/plan-access.model';
import { PlanAccessService } from '../../subscription/plan-access.service';

function checkFeature(route: Parameters<CanActivateFn>[0], state: Parameters<CanActivateFn>[1]) {
  const access = inject(PlanAccessService);
  const router = inject(Router);
  const feature = route.data['requiredFeature'] as FeatureCode | undefined;

  if (!feature || access.hasFeature(feature)) return true;

  return router.createUrlTree(['/parametres/abonnement'], {
    queryParams: {
      upgrade: 'required',
      feature,
      requiredPlan: access.requiredPlan(feature),
      returnUrl: state.url,
    },
  });
}

export const planFeatureGuard: CanActivateFn = (route, state) => checkFeature(route, state);
export const planFeatureChildGuard: CanActivateChildFn = (route, state) => checkFeature(route, state);
